export default {
  textDarkColor: '#211551' /* Text dark color : used for title, bold text etc ... */
  , textRegularColor: '#595179' /* used for regular text */
  , textLightColor: '#86829d',

  tagTextPlaceholderColor: '#aaaaaa',
  textPlaceholderColor: 'rgba(33, 21, 81, 0.5)',

  buttonDarkColorHover: '#9f9dad',
  buttonDarkColor: '#adabbc' /* grey dark: used for icon/button */
  , buttonLightColor: '#eaeaea' /* grey light : used for icon/button */

  , coal: '#2c2d30',
  darkGrey: '#adabbc',
  mediumGrey: '#cecece',
  lightGrey: '#eaeaea',
  veryLightGrey: '#f1f3f4',

  /* Violet color */
  lightVioletColor: '#f1eefb' /* used for : background button */
  , primaryColor: '#643fdb' /* used for : background button */
  , primaryDarkColor: '#512cc5' /* used for : background button icon (a bit darker than the button color) */
  , backgroundPrimaryColor: 'linear-gradient(180deg, #744aff 0%, #643fdb 100%)' /* violet color used in background of some buttons */

  , /* Pink color */
  lightPink: '#ffeaf2',
  pinkColor: '#ff2171',
  pinkDarkColor: '#d60751',

  /* Green color */
  greenColor: '#48d8a9',
  greenDarkColor: '#45c6a0',
  greenLightColor: '#c6feea' /* green light color : */

  , /* Sucess / Green color */
  successColor: '#47c547',
  successDarkColor: '#209e20',

  /* Error / Red color */
  errorColor: '#de3f3f',
  errorDarkColor: '#9e2020',

  /* Grey color */
  borderColor: '#eaeaea' /* grey light color : used for outline buttons, container border, input etc ... */
  , borderColorFocus: '#cecece' /* grey darker color : used for elements when focus ... */

  , backgroundGreyColor: '#f1f3f4',
  backgroundDarkColor: '#2c2d30',

  tagColors: [{ color: '#6853B0', backgroundColor: '#DDD4FA' }, { color: '#2F61A1', backgroundColor: '#D1E5FF' }, { color: '#DE7939', backgroundColor: '#FAE3D4' }, { color: '#259E9E', backgroundColor: '#CDF7F7' }, { color: '#378D43', backgroundColor: '#CFFADB' }, { color: '#8D3787', backgroundColor: '#FBD7FC' }, { color: '#727524', backgroundColor: '#F5F3CE' }, { color: '#754724', backgroundColor: '#F5DBCE' }, { color: '#246675', backgroundColor: '#CEF0F5' }, { color: '#575D7E', backgroundColor: '#CED4F5' }, { color: '#6D6D6D', backgroundColor: '#E6E6E6' }]
};
//# sourceMappingURL=colors.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/styles/colors.js
// module id = 799
// module chunks = 0